import { z } from 'zod';

import { ageSchema } from '@/features/profile/utils/age';
import { bondingPaceSchema } from '@/features/profile/utils/bondingPace';
import { displayNameSchema } from '@/features/profile/utils/displayName';
import { favouriteAgentSchema } from '@/features/profile/utils/favouriteAgent';
import { gameModePreferenceSchema } from '@/features/profile/utils/gameModePreference';
import { inGameCommStyleSchema } from '@/features/profile/utils/inGameCommStyle';
import { languagesSchema } from '@/features/profile/utils/languages';
import { personalityTraitsSchema } from '@/features/profile/utils/personalityTrait';
import { playScheduleSchema } from '@/features/profile/utils/playSchedule';
import { preGameRoutineSchema } from '@/features/profile/utils/preGameRoutine';
import { serversSchema } from '@/features/profile/utils/servers';
import { voiceChatParticipationSchema } from '@/features/profile/utils/voiceChatParticipation';

export const modeSelectionEnum = z.enum(['PLAY_NOW', 'DISCOVER']);

export const onboardingSchema = z.object({
  stats: z.literal(true),
  ['favourite-agent']: favouriteAgentSchema,
  servers: serversSchema,
  ['display-name']: displayNameSchema,
  age: ageSchema,
  languages: languagesSchema,
  ['mode-selection']: modeSelectionEnum,
  ['game-mode-preference']: gameModePreferenceSchema,
  ['in-game-comm-style']: inGameCommStyleSchema,
  ['personality-traits']: personalityTraitsSchema,
  ['voice-chat-participation']: voiceChatParticipationSchema,
  ['play-schedule']: playScheduleSchema,
  ['pre-game-routine']: preGameRoutineSchema,
  ['bonding-pace']: bondingPaceSchema,
  notifications: z.boolean().optional(),
  ['nearly-done']: z.literal(true),
  ['non-toxic']: z.literal(true),
});
